import { c as _c } from "react/compiler-runtime";
import { Card, CardTitle, CardHeader, CardContent, CardDescription } from "@repo/ui/components/ui/card";
import { ErrorBoundary } from "@repo/ui/components/ui/error-boundary";
import { motion } from "motion/react";
type AuthFlowCardProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};
export function AuthFlowCard(t0) {
  const $ = _c(15);
  const {
    title,
    subtitle,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <CardTitle className="text-2xl font-bold mb-5 text-foreground-muted">{title}</CardTitle>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = subtitle && <CardDescription className="text-sm text-foreground-muted">{subtitle}</CardDescription>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <CardHeader>{t1}{t2}</CardHeader>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 10
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      duration: 0.5,
      delay: 0.2,
      ease: "easeOut"
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== children) {
    t7 = <motion.div key="animate" initial={t4} animate={t5} transition={t6}><CardContent className="px-0 pb-0 flex flex-col gap-6">{children}</CardContent></motion.div>;
    $[10] = children;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t7) {
    t8 = <ErrorBoundary showErrorMessage={true}><Card className="w-full p-6 md:p-12 border-0 md:border-1 shadow-lg max-h-full z-10">{t3}{t7}</Card></ErrorBoundary>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}